module.exports = "/_next/static/images/5adefb7fe5e129a4552601a68c79851c-comunidad-logo.jpg.webp";